import { fetchCustomerInquiries, fetchCustomerReports, updateCustomerInquiry, updateCustomerReport } from "../common/firebase/Firestore";
import CustomerInquiry from "../model/homepage/CustomerInquiry";
import CustomerReport from "../model/homepage/CustomerReport";
import { sendInquiryEmail } from "../common/firebase/Function";

/**
 * 고객 신고 리스트 조회 함수
 * @async
 * @function fetchCustomerReportList
 * @returns {Promise<CustomerReport[]>}
 */
const fetchCustomerReportList = async (): Promise<CustomerReport[]> => {
    return await fetchCustomerReports();
};

/**
 * 신고 관리 답변 처리 함수
 * @async
 * @function sendCustomerReportReply
 * @param {string} id - Inquiry Doc ID
 * @param {CustomerInquiry} inquiry - 문의 데이터
 * @returns {Promise<boolean>}
 */
const sendCustomerReportReply = async (id: string, report: CustomerReport) => {
    // 이메일 전송
    await sendInquiryEmail(report.email, report.replyTitle ?? "", "", report.replyContents ?? "");
    // 신고 정보 업데이트
    await updateCustomerReport(id, report);
};

/**
 * 고객 문의 리스트 조회 함수
 * @async
 * @function fetchCustomerInquiryList
 * @returns {Promise<CustomerInquiry[]>}
 */
const fetchCustomerInquiryList = async (): Promise<CustomerInquiry[]> => {
    return await fetchCustomerInquiries();
}
/**
 * 문의 관리 답변 처리 함수
 * @async
 * @function sendCustomerInquiryReply
 * @param {string} id - Inquiry Doc ID
 * @param {CustomerInquiry} inquiry - 문의 데이터
 * @returns {Promise<boolean>}
 */
const sendCustomerInquiryReply = async (id: string, inquiry: CustomerInquiry) => {
    // 이메일 전송
    await sendInquiryEmail(inquiry.email, inquiry.replyTitle ?? "", "", inquiry.replyContents ?? "");
    // 문의 정보 업데이트
    await updateCustomerInquiry(id, inquiry);
};

const sendRequestHomepageWork = async (title: string, contents: string) => {
    const email = "admin@lyrevoice.com";
    // 이메일 전송
    await sendInquiryEmail(email, title, "", contents);
}

export { fetchCustomerReportList, sendCustomerReportReply, fetchCustomerInquiryList, sendCustomerInquiryReply, sendRequestHomepageWork }; 